module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$i18n.locale === 'de' || _vm.$i18n.locale === 'de-at') ? _c('privacy-de') : _c('privacy-en')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8ac785c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Privacy.vue
// module id = 579
// module chunks = 0